import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGoogleAdsInit } from "@/ads/hooks/useGoogleAdsInit";
import { Plato } from "@/components";
import { LeaderBoard } from "@/components/Ads";
import { OpenFormStickyBanner } from "@/components/utilsComponents/openFormStickyBanner/OpenFormStickyBanner";
import { useConfig } from "@/contexts/cdpConfig";
import { useClassifiedId } from "@/contexts/classified";
import { useCustomerActionExposeSectionView, useIsBICLayout, useTestId, useTrackingLegacyView, useTrackingView, } from "@/hooks";
import { PrintTemplateCss } from "@/templates/PrintTemplateCss";
import { saveSeenToStorage } from "@/utils/saveContactAndSeenToStorage/saveContactAndSeenToStorage";
import { useEffect, useState } from "react";
import { CdpPreviewTemplateCSS } from "./CdpPreviewTemplateCss";
import { Wrapper } from "./Wrapper";
import { useKameleoonConsent } from "@/hooks/kameleoon";
import { useClassifiedAnalytics } from "@/hooks/tracking/classifiedAnalytics";
import { CA_EVENT_TYPES } from "@/types/classifiedAnalytics";
import { TemplateDefault } from "./TemplateDefault";
import { TemplateBIC } from "@/BICLayout/TemplateBIC";
export const TemplateWrapper = () => {
    const testId = useTestId("main");
    const [loadPrintTemplate, setLoadPrintTemplate] = useState(false);
    const isPreviewMode = useConfig().previewMode;
    const { sendClassifiedAnalyticsEvent } = useClassifiedAnalytics();
    const isBICLayout = useIsBICLayout();
    const classifiedId = useClassifiedId();
    useKameleoonConsent();
    // saving to local storage after 5 seconds on the page,
    // it prevents showing a 'seen' tag when the user opens the cdp for the first time
    useEffect(() => {
        const timer = setTimeout(() => {
            saveSeenToStorage(classifiedId);
        }, 5000);
        return () => clearTimeout(timer);
    }, [classifiedId]);
    useEffect(() => {
        setLoadPrintTemplate(true);
    }, []);
    // Legacy tracking solution on French brands also known as "Harvest"
    useTrackingLegacyView();
    useTrackingView();
    // wl classified analytics call
    useEffect(() => {
        sendClassifiedAnalyticsEvent(CA_EVENT_TYPES.PAGE_VIEW);
    }, [sendClassifiedAnalyticsEvent]);
    useGoogleAdsInit();
    // Legacy tracking solution on German brands
    useCustomerActionExposeSectionView();
    return (_jsxs(_Fragment, { children: [isPreviewMode ? _jsx(CdpPreviewTemplateCSS, {}) : null, _jsx(OpenFormStickyBanner, {}), _jsx(LeaderBoard, {}), _jsxs(Wrapper, { testId: testId, children: [loadPrintTemplate && _jsx(PrintTemplateCss, {}), isBICLayout ? _jsx(TemplateBIC, {}) : _jsx(TemplateDefault, {})] }), _jsx(Plato, {})] }));
};
